export const environment = window.location.href;
export const ifProduction = () => {
  return !environment.includes("dev") && !environment.includes("localhost");
};
export const environmentHost = () => {
  return ifProduction()
    ? "https://soft.edu.dobot.cc"
    : "https://dev.soft.edu.dobot.cc";
};
